import { SelectOption } from 'components/new-ui/composed/formSelect/FormSelect';
import { DeclarationCountry } from './declaration-country';

export enum DeclarationInternalType {
    IMPORT = 'IMPORT',
    IMPORT_NEW = 'IMPORT_NEW',
    EXPORT = 'EXPORT',
    ENS = 'ENS',
    ETD = 'ETD',
    ARRIVAL = 'ARRIVAL',
    TEMPORARY = 'TEMPORARY',
    GVMS = 'GVMS',
    PBN = 'PBN',
    NCTS = 'NCTS',
    ARRIVAL_NOTIFICATION_ICS2 = 'ARRIVAL_NOTIFICATION_ICS2',
}

export const irelandInternalDeclarationTypes = [
    {
        id: DeclarationInternalType.IMPORT,
        value: 'Import (AIS)',
    },
    { id: DeclarationInternalType.TEMPORARY, value: 'TSD' },
    { id: DeclarationInternalType.ETD, value: 'ETD' },
    { id: DeclarationInternalType.EXPORT, value: 'Export (AES)' },
    { id: DeclarationInternalType.ARRIVAL, value: 'Arrival at exit' },
];

export const ukInternalDeclarationTypes = [
    {
        id: DeclarationInternalType.IMPORT,
        value: 'Import',
    },
    { id: DeclarationInternalType.EXPORT, value: 'Export' },
];

export const ics2InternalDeclarationTypes = [
    {
        id: DeclarationInternalType.ENS,
        value: 'ENS',
    },
    { id: DeclarationInternalType.ARRIVAL_NOTIFICATION_ICS2, value: 'Arrival Notification' },
];

const uniqueById = (options: SelectOption[]): SelectOption[] =>
    Array.from(new Map(options.map((o) => [o.id, o])).values());

export const getDeclarationInternalTypeSelectOptions = (country?: DeclarationCountry): SelectOption[] => {
    if (country === DeclarationCountry.IRELAND) {
        return irelandInternalDeclarationTypes;
    }

    if (country === DeclarationCountry.UK) {
        return ukInternalDeclarationTypes;
    }

    if (country === DeclarationCountry.EU) {
        return ics2InternalDeclarationTypes;
    }

    return uniqueById([
        ...irelandInternalDeclarationTypes,
        ...ukInternalDeclarationTypes,
        ...ics2InternalDeclarationTypes,
    ]);
};
